import { Inject, Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { CoreConfig } from '../utils/config';

@Pipe({
  name: 'ocr',
})
export class OCRPipe implements PipeTransform {
  constructor(@Inject(CoreConfig.API_BASE_URL) public baseUrl: string, private appConfig: AppConfigService) {}

  transform(OCRResultPacket: any, direction: string = 'in'): any {
    let url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/noImage.png`;

    if (OCRResultPacket == undefined) {
      url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/noImage.png`;
    } else {
      if (direction == 'in' || direction == 'out') {
        url = `${this.baseUrl}movements/image/${this.getFormatDate(new Date())}/${this.getFormatMovImg(OCRResultPacket.front.id_mov)}/_F`;
      }
    }
    return url;
  }

  private getFormatDate(date: Date): string {
    let modifiedDate = new Date(date);
    modifiedDate = new Date(modifiedDate.getTime() - modifiedDate.getTimezoneOffset());
    const year = modifiedDate.getFullYear();
    const month = ('0' + (modifiedDate.getMonth() + 1).toString()).slice(-2);
    const day = ('0' + modifiedDate.getDate().toString()).slice(-2);
    return year + month + day;
  }

  private getFormatMovImg(movement: any): string {
    if (!movement) return;
    return movement.toString();
  }
}
